/* global axios */
import ApiClient from './ApiClient';

class FunnelAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  async create(data) {
    return axios.post(this.url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  async update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async getStageStats(funnelId, filterParams = {}) {
    return axios.get(`${this.url}/${funnelId}/stage_stats`, {
      params: filterParams,
    });
  }

  // SiteUP CRM (relatorios r1): numeros da etapa agregados no banco. O modal do
  // "Relatorio da etapa" somava os 25 cartoes carregados na coluna.
  async getStageReport(funnelId, stageId, filterParams = {}) {
    return axios.get(`${this.url}/${funnelId}/stage_report`, {
      params: { ...filterParams, stage_id: stageId },
    });
  }

  // SiteUP CRM (relatorios r1): indicadores da vista "Numeros" em SQL, sem
  // depender da lista de ate 100 cartoes.
  async getDashboardStats(funnelId) {
    return axios.get(`${this.url}/${funnelId}/dashboard_stats`);
  }

  // SiteUP CRM (relatorios r1, decisao 27): quantos cartoes de uma etapa ainda
  // nao estao fechados, e o andamento do lote quando ele estiver rodando.
  async getStageOutcomeProgress(funnelId, stageId) {
    return axios.get(`${this.url}/${funnelId}/apply_stage_outcome_progress`, {
      params: { stage_id: stageId },
    });
  }

  // Marca como ganhos (ou perdidos) os cartoes que ja estao na etapa. Etapa
  // grande volta 202 e segue em job; o progresso sai no endpoint acima.
  async applyStageOutcome(funnelId, stageId) {
    return axios.post(`${this.url}/${funnelId}/apply_stage_outcome`, {
      stage_id: stageId,
    });
  }

  async getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  async getAll() {
    return axios.get(this.url);
  }

  async getAgenda(funnelId, { from, to, includeTasks, assigneeIds } = {}) {
    const params = { from, to };
    // Sem include_tasks o endpoint segue devolvendo o array antigo de itens.
    if (includeTasks) params.include_tasks = true;
    if (Array.isArray(assigneeIds) && assigneeIds.length) {
      params.assignee_ids = assigneeIds;
    }
    return axios.get(`${this.url}/${funnelId}/agenda`, { params });
  }
}

export default new FunnelAPI();
